import React from 'react';
import repeat from 'lodash/repeat';
import { withStyles } from '@material-ui/core/styles';
import { Col, Row } from 'react-flexa';
import Image from '../../../../components/Image';
import Typography from '../../../../components/Typography';
import { imageRoot } from '../../../../../env.config';

const styles = theme => ({
  root: {
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: '3px',
    margin: '10px auto',
    boxShadow: '0 10px 10px 0 rgba(0,0,0,0.05)',
    minHeight: '7.5rem'
  },
  markerCircle: {
    background: `url(${imageRoot}/pricingpage/marker-circle-red.svg)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    textAlign: 'center'
  },
  title: {
    textAlign: 'left'
  },
  markup: {
    paddingTop: '10px',
    marginBottom: '0',
    [theme.breakpoints.down('xs')]: {
      paddingTop: '5px'
    }
  },
  dollars: {
    paddingBottom: '10px',
    marginTop: '0',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '5px'
    }
  },
  pipelineStop: {
    letterSpacing: '3px',
    padding: '1.5rem',
    fontWeight: '900',
    [theme.breakpoints.down('sm')]: {
      letterSpacing: '1px'
    },
    [theme.breakpoints.down('xs')]: {
      margin: '.5rem',
      padding: '.5rem'
    }
  }
});

class RetailContent extends React.Component {
  render() {
    const { classes, id, title, markup } = this.props;
    const titleCols = markup ? 7 : 10;
    return (
      <div className={classes.root}>
        <Row
          gutter={0}
          style={{ paddingTop: '10px', paddingBottom: '10px' }}
          alignItems="center"
        >
          <Col xs={0} sm={2}>
            <Image src={`/homepage/image-maps/${id}.png`} />
          </Col>
          <Col xs={0} sm={titleCols} className={classes.title}>
            <Typography
              className={classes.pipelineStop}
              variant="body1"
              color="secondary.dark"
              upper
              bold
            >
              {title}
            </Typography>
          </Col>
          {markup && (
            <Col xs={0} sm={3} className={classes.markerCircle}>
              <div>
                <Typography
                  className={classes.markup}
                  variant="subtitle1"
                  color="primary"
                  bold
                  upper
                >
                  markup
                </Typography>
                <Typography
                  className={classes.dollars}
                  variant="subtitle1"
                  color="primary"
                  bold
                  upper
                >
                  {repeat('$', markup)}
                </Typography>
              </div>
            </Col>
          )}
          <Col xs={12} sm={0}>
            <div>
              <Image src={`/homepage/image-maps/${id}.png`} />
            </div>
            <div>
              <Typography
                className={classes.pipelineStop}
                variant="body1"
                color="secondary.dark"
                upper
                bold
              >
                {title}
              </Typography>
            </div>
            {markup && (
              <div>
                <Typography
                  className={classes.markup}
                  variant="subtitle1"
                  color="primary"
                  bold
                  upper
                >
                  markup
                </Typography>
                <Typography
                  className={classes.dollars}
                  variant="subtitle1"
                  color="primary"
                  bold
                  upper
                >
                  {repeat('$', markup)}
                </Typography>
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default withStyles(styles)(RetailContent);
